import State from "./EvaluatorState"
import Control from "./EvaluatorControl"
// import Game from 'play_perfect/Game'
import Hand from './Hand'
import Results from './Results'
import HandDisplay from './HandDisplay'


class Evaluator {

constructor (initialState={}){
  this.state = new State()
  Object.assign(this.state, initialState)
}


init(){
  HandDisplay.init()
  Results.init()
  //card_sectore.init()
  // this code must run before vue.effect
  if (this.state.deepLink) {
    debug.log('deepLink!')
    window.delayedInit = function(){
      window.evaluator.addJQ()
      debug.log('delayedInit')
      window.evaluator.changeGame(true)
    }
    window.onRuntimeInitialized = function(){
      debug.log('deep link timer!')
      window.evaluator.showWaitNotice()
      setTimeout(window.delayedInit, window.evaluator.state.wasmTTL)
    }
  } else {
    window.onRuntimeInitialized = function () {
      window.evaluator.addJQ()
    }
  }

}

addJQ(){
  $('#clear').on('click', evaluator.clearHandler)
  $('#evaluate').on('click', evaluator.evaluateHandler)
  $('.card-selector span.mini-card').on('click', evaluator.cardClickHandler)
}

showWaitNotice(){
  Control.waitNotice.show()
}

clearHandler(){
  machine.game.clearHand()
  HandDisplay.clear()
  Results.hideEVs()
  HandDisplay.hideBest()
  $('.svg-card.selected').removeClass('selected')
  window.evaluator.setNotice()
}

evaluateHandler(){
  debug.log("Evaluate hand")
  if (window.evaluator.state.notAllCardsSelected) return
  Results.computeEVs()
  Results.buildDisplay()
  HandDisplay.showBest()
  $("#evaluate").addClass('pure-button-disabled')
  $("#scroll-down").show()
}

cardClickHandler(){
  const cid = $(this).data("cid")
  const card = $(this).data("card")
  const svg = $(this).find('.svg-card')
  debug.log(card, cid, machine.game.numCardsSelected, machine.game.hand);
  window.evaluator.cardClicked(card, cid, svg);
}

changeGame(selectCards) {
  const gameData = this.state.gameData
  debug.log("changeGame", gameData)
  Control.waitNotice.show()
  // TODO: move this to component
  $("#gameSelector option[value='choose']").remove()
  const gameChanged = machine.changeGame(gameData.game)

  Control.toggleWildCards(gameData.wild)

  if (selectCards) this.clickCards(this.state.hand)
  this.setNotice()
  Control.waitNotice.hide()
  if (gameChanged) {
    if (selectCards) Control.evaluateButton.click()
    // NOTICE we only rebuild the display hereif the hand WAS equal...
    if (this.state.allCardsSelected && machine.game.hand.equal(machine.game.handLastEvaluated)) Results.buildDisplay()
    this.showOrHideResults()
    this.updateURL() // just incase NO cards clicked?
  }
}

updateURL() {
  const gameData = this.state.gameData
  this.updateStateHand()
  const url = [gameData.url, this.state.hand].join('/')
  window.history.replaceState({ gameData }, 'VP Hand Evaluator', url)
}

updateStateHand() {
  this.state.hand = machine.game.hand.toHuman()
}

clickCards(hand) {
  if (!hand || hand.length == 0) return
  debug.log("clickCards (from deeplink)", hand)
  hand.filter(cCard => {
    return cCard != '0b'
  }).map((card) => this.clickCard(card))
}

clickCard(card) {
  debug.log("clicking card", card)
  $('.card-selector').find(`#${card}`).trigger('click')
}

setNotice() {
  if (!this.state.ready) return this.somethingWentWrong();
  Control.clearButton.toggle(this.state.someCardsSelected)
  Control.selectCardsNotice.toggle(this.state.notAllCardsSelected)
  if (this.state.currentUser) {
    if (this.state.allCardsSelected && !machine.game.hand.equal(machine.game.handLastEvaluated)) {
      Control.evaluateButton.enable()
    } else {
      Control.evaluateButton.disable()
    }
  }
}

somethingWentWrong() {
  debug.log("something went wrong", machine.ready(), this.state.wasmTTL)
  Control.reloadNotice.show()
  this.state.wasmTTL = this.state.wasmTTL + 500
}

cardClicked(card, cid, svg) {
  if (machine.game.cardInHand(cid)) {
    debug.log("removing", card, cid)
    machine.game.removeCardFromHand(cid)
    $(svg).removeClass('selected')
    HandDisplay.changeCard(card, "0b")
  } else {
    if (this.state.notAllCardsSelected) {
      debug.log("adding", card, cid)
      $(svg).addClass('selected')
      HandDisplay.changeCard("0b", card)
      machine.game.addCardToHand(cid)
    }
  }
  debug.log('new', machine.game.hand);
  this.updateURL()
  // game may not be fully ready here....
  if (!this.state.ready) return
  this.setNotice()
  this.showOrHideResults()
}

showOrHideResults() {
  if (machine.game && Hand.equal(machine.game.handLastEvaluated, machine.game.hand)) {
    $('#evs').show();
    $("#scroll-down").show();
    HandDisplay.showBest();
  } else {
    Results.hideEVs();
    HandDisplay.hideBest();
    $("#scroll-down").hide();
  }
}

}

export default Evaluator